import {
  Card,
  CardContent,
  Icon,
  ListItemText,
  Radio,
  styled,
} from '@nextiva/next-ui-components';

export const CardStyled = styled(Card)<{ checked: boolean }>`
  max-width: 232px;
  min-height: 176px;
  gap: 5px;
  background-color: ${({ checked, theme }) =>
    checked ? theme.palette.blue.A50 : theme.palette.common.white};
  border: ${({ checked, theme }) =>
    checked ? `1px solid ${theme.palette.blue[800]}` : `1px solid transparent`};
  &:hover {
    background-color: ${({ checked, theme }) =>
      checked ? theme.palette.blue[50] : theme.palette.blue.A50};
  }
`;

export const CardContentStyled = styled(CardContent)`
  position: relative;
  min-height: 176px;
  padding: 16px;
  &:last-child {
    padding-bottom: 16px;
  }
`;

export const ListItemTextStyled = styled(ListItemText)`
  margin: 0px;
`;

export const RadioStyled = styled(Radio)`
  color: transparent;
  position: absolute;
  top: 0px;
  right: 0px;
  &:hover {
    color: transparent;
  }
`;

export const CheckIcon = styled(Icon)`
  position: absolute;
  top: 4px;
  right: 4px;
  color: #acaeb8;
`;
